import "./Navbar.scss";
import UserInfo from "./user-info/UserInfo";
import { Menubar } from 'primereact/menubar';
import { ReactComponent as RunwayUkLogo } from "./assets/RunwayUkLogo.svg"
import { ReactComponent as RunwayUSLogoText } from "./assets/RunwayUSLogoText.svg"
import { ROUTES } from "../../config/routes";
import { Link } from "react-router-dom";

import UpdateProfileModal from "./update-profile/UpdateProfile";
import { useToggle } from "../../hooks";

function Navbar({  }) {

  const [onAdd, setShowAdd] = useToggle(false)
  const [onOnboard, setShowOnboard] = useToggle(false)

  const runwayUsLogo = (
    <Link to={ROUTES.HOME}>
      <div className="flex w-7 align-items-center" >
        <RunwayUkLogo className="RunwayUSLogoIcon " />
        <RunwayUSLogoText className="RunwayUSLogoText " />
      </div>
    </Link>
  )
  return (
    <>
     
      <UpdateProfileModal onShow={onOnboard} onHide={setShowOnboard} />
      <Menubar className="Navbar w-full " start={runwayUsLogo} end={<UserInfo setShowAdd={setShowAdd} setShowOnboard={setShowOnboard} />} />
    </>
  );
}

Navbar.defaultProps = {
  showUserInfo: true
}

export default Navbar;
